export default "__VITE_ASSET__BpjqE1qv__"